import React, { useState, useEffect } from "react";

const OfficeHoursView = ({ data }) => {
  const [details, setDetails] = useState({});

  useEffect(() => {
    setDetails({
      Monday: ["Monday: ", data.mondayStoreHours],
      Tuesday: ["Tuesday: ", data.tuesdayStoreHours],
      Wednesday: ["Wednesday: ", data.wednesdayStoreHours],
      Thursday: ["Thursday: ", data.thursdayStoreHours],
      Friday: ["Friday: ", data.fridayStoreHours],
      Saturday: ["Saturday: ", data.saturdayStoreHours],
      Sunday: ["Sunday: ", data.sundayStoreHours],
    });
  }, [data]);

  return (
    <div className="space-y-1">
      <div className="grid grid-cols-1 md:grid-cols-1 text-xs mx-10">
        {Object.values(details).map((item, i) => {
          return (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div
                className="grid grid-cols-2 md:grid-cols-2 sm:grid-cols-2 "
                key={i}
              >
                <label className="expandedLabel fontExpand text-left">
                  <span className="">{item[0]}</span>
                </label>
                <span className="expandedData fontExpand">{item[1]}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OfficeHoursView;
